export function debounce(func, wait = 300) {
  let timeout;
  
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

export function debounceAsync(func, wait = 300) {
  let timeout;
  let currentPromise = null;
  
  return function executedFunction(...args) {
    if (currentPromise) {
      clearTimeout(timeout);
    }
    
    currentPromise = new Promise((resolve) => {
      timeout = setTimeout(async () => {
        try {
          const result = await func(...args);
          resolve(result);
        } catch (error) {
          console.error('Debounced function error:', error);
          resolve(null);
        } finally {
          currentPromise = null;
        }
      }, wait);
    });
    
    return currentPromise;
  };
} 